interface Option<T> {
  value: T;
  label: React.ReactNode;
  /**
   * Data attributes to apply to the button element
   * @example { 'data-intercom-target': 'my-button', 'data-testid': 'email-tab' }
   */
  dataAttributes?: Record<string, string>;
}

interface SegmentedControlProps<T extends string> {
  options: Option<T>[];
  value: T;
  onChange: (value: T) => void;
}

function SegmentedControl<T extends string>({
  options,
  value,
  onChange,
}: SegmentedControlProps<T>) {
  return (
    <div className="flex border border-teal-600 rounded-md overflow-hidden">
      {options.map((option) => (
        <button
          key={option.value}
          onClick={() => onChange(option.value)}
          className={`flex-1 py-3 px-4 text-sm font-medium text-center transition-colors ${
            value === option.value
              ? 'text-white bg-teal-600'
              : 'text-teal-600 hover:text-teal-700 hover:bg-gray-50'
          }`}
          {...option.dataAttributes}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}

export default SegmentedControl;
